const getBrandFamily = (brand) => {
  if (brand === 'anf' || brand === 'kids') {
    return 'anf';
  }
  return 'hol';
};

export default getBrandFamily;
